export const SUPPORTED_LOCALES = ["en", "es", "fr", "he", "ru"] as const;
export const DEFAULT_LOCALE = "en";
export const RTL_LANGUAGES = ["he"];
export const FALLBACK_NAMESPACE = "common";

export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

export function isRTL(locale: string): boolean {
	return RTL_LANGUAGES.includes(locale);
}

export function getDirection(locale: string): "ltr" | "rtl" {
	return isRTL(locale) ? "rtl" : "ltr";
}

export function getHtmlLang(locale: string): string {
	const langMap: Record<string, string> = {
		en: "en",
		he: "he-IL",
		es: "es",
		fr: "fr",
		ru: "ru",
	};

	return langMap[locale] || locale;
}
